import Vue from 'vue'
import Router from 'vue-router'
//import Home from '@/components/Home'

Vue.use(Router)

export default new Router({
  routes: [
    {path: '/', name: 'Home', component: require('@/components/pages/Home').default},
    {path: '/camping', component: require('@/components/pages/camping/Index').default},
    {path: '/canchas', component: require('@/components/pages/canchas/Index').default},
    {path: '/escuelas/virtuales', component: require('@/components/pages/evirtual/Index').default},
    {path: '/escuelas/virtuales/:slug', component: require('@/components/pages/evirtual/courseDetails').default, props: true},
    {path: '/rvirtual/:slug', component: require('@/components/pages/evirtual/register').default, props: true},
    {path: '/escuelas-presenciales', component: require('@/components/pages/epresencial/Index').default},
    {path: '/rpresencial/:slug', component: require('@/components/pages/epresencial/register').default, props: true},
    {path: '/subastas', component: require('@/components/pages/subastas/index').default, props: true},
    {path: '/raices-de-vida', component: require('@/components/pages/raices/index').default, props: true},
    {path: '/raices-de-vida/register', component: require('@/components/pages/raices/register').default},
    {path: '/abonados', component: require('@/components/pages/abonados/Index').default},
    {path: '/plantas-vivero', component: require('@/components/pages/plantitas/Index').default},
    {path: '/plantas-vivero', component: require('@/components/pages/plantitas/Index').default},
    {path: '/entradas', component: require('@/components/pages/entradas/Index').default},
    {path: '/clubmet', component: require('@/components/pages/clubmet/Index').default},
    {path: '/concesiones-y-eventos', component: require('@/components/pages/concesiones/Index').default},
    {path: '/parking', component: require('@/components/pages/parking/Index').default},
    {path: '/:slug', component: require('@/components/pages/product/Index').default},
    {path: '/not-available', component: require('@/components/pages/errors/not-available').default},
  ],
  mode:'history',
})



// WEBPACK FOOTER //
// ./src/router/index.js